import React from 'react';

const AssignmentsPage: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="card p-6">
        <h1 className="text-2xl font-bold">Assignments</h1>
        <p className="mt-2 text-gray-600">Assignments page content</p>
      </div>
    </div>
  );
};

export default AssignmentsPage;